import { h, render } from 'preact'
import { Widget } from './widget.jsx'
import { readConfig, isHostAllowed } from './config.js'
import cssText from './styles.css?inline'

function mount() {
  const config = readConfig()
  if (!isHostAllowed(config)) return

  const host = document.createElement('div')
  host.id = 'ai-etibox-widget-host'
  document.body.appendChild(host)

  const shadow = host.attachShadow({ mode: 'open' })
  const style = document.createElement('style')
  style.textContent = cssText
  shadow.appendChild(style)

  const mountPoint = document.createElement('div')
  shadow.appendChild(mountPoint)

  render(h(Widget, { config }), mountPoint)
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', mount)
} else {
  mount()
}
